<app-toast></app-toast>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="0" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.dashboard' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="0"></app-mobile-topbar>
            <div class="flex gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.overview' | transloco }}" link="/dashboard/overview"></app-tab-button>
                <app-tab-button label="{{ 'shared.electricity' | transloco }}"
                    link="/dashboard/electricity"></app-tab-button>
                <app-tab-button label="{{ 'shared.gas' | transloco }}" [isActive]="true"
                    link="/dashboard/gas"></app-tab-button>
            </div>

            <!-- No membership popup -->
            <div class="mt-4">
                <app-no-membership-popup [visible]="!hasPlusSubscription"></app-no-membership-popup>
            </div>

            <!-- Extraction ongoing popup -->
            <div class="mt-4">
                <app-extraction-ongoing-popup [visible]="isExtractionOngoing"></app-extraction-ongoing-popup>
            </div>

            <!-- Electricity costs -->
            <div class="flex flex-wrap gap-2 max-w-ultrawide min-h-[600px] mobile:flex-col mobile:h-auto">
                <!-- Left side -->
                <div
                    class="mt-4 flex-[2] flex flex-col gap-2 min-w-[500px] mobile:min-w-[300px] rounded-[16px] border-[1px] border-border bg-[#FFFFFF] shadow-sm mobile:w-full">
                    <div class="flex mt-4 justify-between mobile:flex-col">
                        <div class="flex flex-col gap-4 min-h-[70px] justify-between">
                            <div class="flex flex-col flex-grow justify-center text-center">
                                <p class="text-primary font-semibold ml-4 mr-4 mobile:text-sm">{{ 'dashboard.gas_costs'
                                    |
                                    transloco }}</p>
                            </div>
                            <div class="h-[2px] w-full bg-primary"></div>
                        </div>
                        <div class="min-h-[70px]  flex flex-grow items-end justify-start mobile:hidden">
                            <div class="h-[2px] w-full bg-border"></div>
                        </div>
                        <div class="min-h-[70px] flex flex-col gap-2 justify-between mobile:h-auto mobile:mt-2">

                            <div class="flex flex-wrap gap-2 mr-4 ml-2 items-center mobile:flex-col">
                                <div class="min-w-[250px] desktop:flex-[1] mobile:w-[300px]">
                                    <app-custom-dropdown [options]="locationsDropdownOptions"
                                        [(selectedOption)]="selectedLocationDropdown"
                                        (selectedOptionChange)="locationChange()"></app-custom-dropdown>
                                </div>
                                <div
                                    class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                    @if(gasCostsComparisonDate === undefined) {
                                    <p class="mobile:text-sm hover:cursor-pointer min-w-[50px]"
                                        (click)="openComparisonYearSelect()">
                                        {{ 'dashboard.comparison_year' |
                                        transloco }}</p>
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                    } @else {
                                    <p-calendar class="w-[50px]" [(ngModel)]="gasCostsComparisonDate" view="year"
                                        [minDate]="datePickerMinYear" [maxDate]="gasForecastMaxDate"
                                        readonlyInput="true" dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                        (onClose)="loadGasComparisonCostsData()" />
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                    }
                                </div>
                                <div
                                    class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                    <p-calendar class="w-[50px]" [(ngModel)]="gasCostsDate" view="year"
                                        [minDate]="datePickerMinYear" [maxDate]="gasForecastMaxDate"
                                        readonlyInput="true" dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                        (onClose)="loadGasCostsData()" />
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                </div>
                            </div>
                            <div class="h-[2px] w-full bg-border mobile:mt-2"></div>
                        </div>
                    </div>

                    <div class="flex flex-col items-center">
                        <div class="flex gap-0 w-[95%] h-auto">
                            <div class="relative h-auto w-[95%] p-4 mobile:p-2">
                                <div class="h-[150px] largeScreen:h-[200px] w-[95%]">
                                    <app-gas-costs-averages [showDummyData]="showDummyData"
                                        [averagePricePerSmcData]="averagePricePerSmcData"
                                        [forecastedStartMonth]="forecastedStartMonth"></app-gas-costs-averages>
                                </div>
                                <div class="h-[400px] largeScreen:h-[500px] w-[95%] mobile:h-[300px]">
                                    <app-gas-costs-chart [showDummyData]="showDummyData"
                                        [invoiceAmountActualData]="invoiceAmountActualData"
                                        [invoiceAmountForecastData]="invoiceAmountForecastData"></app-gas-costs-chart>
                                </div>

                                <app-complete-energy-profile
                                    [showPopup]="noDataDialogShowCosts"></app-complete-energy-profile>
                            </div>
                            <app-flex-upgrade [showUpgrade]="showUpgradeGasCosts"
                                [showTextUnder]="true"></app-flex-upgrade>
                        </div>
                    </div>
                </div>
                <!-- Right side -->
                <div class="mt-4 flex-[1] min-w-[500px] mobile:min-w-[300px] flex flex-col gap-2 mobile:w-full">
                    <div class="w-full flex flex-col justify-between rounded-[16px] border-[1px] border-border bg-secondary-100 shadow-sm"
                        [ngClass]="[gasCostsComparisonDate === undefined ? 'h-auto' : 'h-1/2']">
                        <app-comparison-year [showDummyData]="showDummyData" [year]="compariosonCurrentyear"
                            [lastFullMonthCost]="compariosonCurrentlastFullMonthCost"
                            [lastFullMonthkWh]="compariosonCurrentlastFullMonthSmc"
                            [yearToDateCost]="compariosonCurrentyearToDateCost"
                            [yearToDatekWh]="compariosonCurrentyearToDateSmc"
                            [forecastFullYearCost]="compariosonCurrentforecastFullYearCost"
                            [forecastFullYearkWh]="compariosonCurrentforecastFullYearSmc"
                            [showUpgrade]="showUpgradeGeneral" unit="smc"></app-comparison-year>


                    </div>
                    <div class="w-full flex flex-col rounded-[16px] border-[1px] border-border bg-primary-100 shadow-sm h-1/2"
                        *ngIf="gasCostsComparisonDate !== undefined">
                        <app-comparison-year [isComparisonYear]="true" [showDummyData]="showDummyData"
                            [year]="compariosonOlderyear" [lastFullMonthCost]="compariosonOlderlastFullMonthCost"
                            [lastFullMonthkWh]="compariosonOlderlastFullMonthSmc"
                            [yearToDateCost]="compariosonOlderyearToDateCost"
                            [yearToDatekWh]="compariosonOlderyearToDateSmc"
                            [forecastFullYearCost]="compariosonOlderforecastFullYearCost"
                            [forecastFullYearkWh]="compariosonOlderforecastFullYearSmc"
                            [showUpgrade]="showUpgradeGeneral" unit="smc"></app-comparison-year>
                    </div>
                </div>
            </div>

            <!-- Consumption -->
            <div class="mt-4 flex gap-2 max-w-ultrawide min-h-[600px] mobile:flex-col mb-4">
                <div
                    class="mt-4 w-full flex flex-col gap-2 rounded-[16px] border-[1px] border-border bg-[#FFFFFF] shadow-sm h-full mobile:w-full">
                    <div class="flex mt-4 justify-between mobile:flex-col">
                        <div class="flex flex-col gap-4 min-h-[70px] justify-between">
                            <div class="flex flex-col flex-grow justify-center text-center">
                                <p class="text-primary font-semibold ml-4 mr-4 mobile:text-sm">{{
                                    'dashboard.consumption_details_gas' |
                                    transloco }}</p>
                            </div>
                            <div class="h-[2px] w-full bg-primary"></div>
                        </div>
                        <div class="min-h-[70px]  flex flex-grow items-end justify-start mobile:hidden">
                            <div class="h-[2px] w-full bg-border"></div>
                        </div>
                        <div class="min-h-[70px] flex flex-col justify-between mobile:h-auto mobile:mt-2">

                            <div class="flex gap-2 mr-4 items-center mobile:flex-col">
                                <p class="text-sm text-neutral-500">{{ 'dashboard.show_additional_years' | transloco }}
                                </p>
                                <div
                                    class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                    <p-calendar class="w-[50px]" [(ngModel)]="consumptionAndCostsDate" view="year"
                                        [minDate]="datePickerMinYear" [maxDate]="gasForecastMaxDate"
                                        readonlyInput="true" dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                        (onClose)="loadConsumptionAndCostData()" />
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                </div>
                            </div>
                            <div class="h-[2px] w-full bg-border mobile:mt-2"></div>
                        </div>
                    </div>

                    <div class="flex desktop:flex-wrap gap-2 justify-between w-full mobile:flex-col">
                        <!--Left-->
                        <div class="desktop:flex-[2] min-w-[400px] mobile:min-w-[300px]">
                            <div class="flex gap-0 h-full w-full">
                                <div class="relative h-full w-[95%] p-4 mobile:p-2">
                                    <div class="h-[500px] largeScreen:h-[600px]  mobile:h-[400px] w-[95%]">
                                        <app-gas-consumption-chart [showDummyData]="showDummyData"
                                            [consumption]="cacl_consumption"
                                            [consumptionForecasted]="cacl_consumptionForecasted"
                                            [costsPerSmc]="cacl_costsPerSmc"
                                            [costsPerSmcForecastedStartMonth]="cacl_costsPerSmcForecastedStartMonth"
                                            [totalCost]="cacl_totalCost"
                                            [totalCostForecastedStartMonth]="cacl_totalCostForecastedStartMonth"></app-gas-consumption-chart>

                                    </div>

                                    <app-complete-energy-profile
                                        [showPopup]="noDataDialogShowConsumptionCosts"></app-complete-energy-profile>
                                </div>
                                <app-flex-upgrade [showUpgrade]="showUpgradeConsumption"
                                    [showTextUnder]="true"></app-flex-upgrade>
                            </div>
                        </div>
                        <!--Right-->
                        <div
                            class="h-[500px] largeScreen:h-[600px] desktop:flex-[1] min-w-[300px] mobile:min-w-[300px] mobile:h-[300px] mobile:w-full p-4 mobile:p-2">
                            <app-gas-consumption-quartal-chart [showDummyData]="showDummyData"
                                [smcQuarterData]="smcQuarterData"
                                [year]="consumptionAndCostsDataYear"></app-gas-consumption-quartal-chart>
                        </div>
                    </div>


                </div>
            </div>

            <!-- Cost Analysis -->
            <div
                class="mt-4 flex flex-col gap-2 rounded-[16px] mobile:min-w-[300px] border-[1px] border-border bg-[#FFFFFF] shadow-sm mobile:w-full">
                <div class="flex mt-4 justify-between mobile:flex-col">
                    <div class="flex flex-col gap-4 min-h-[70px] justify-between">
                        <div class="flex flex-col flex-grow justify-center text-center">
                            <p class="text-primary font-semibold ml-4 mr-4 mobile:text-sm">{{ 'shared.cost_analysis'
                                |
                                transloco }}</p>
                        </div>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="min-h-[70px]  flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                    <div class="min-h-[70px] flex flex-col justify-between mobile:h-auto mobile:mt-2">

                        <div class="flex gap-2 mr-4 items-center mobile:justify-center">
                            <div
                                class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                @if(costAnalysisMonth === undefined) {
                                <p class="mobile:text-sm hover:cursor-pointer" (click)="openMonthSelect()">
                                    {{ 'archive.overview.month' |
                                    transloco }}</p>
                                <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                } @else {
                                <p-calendar class="w-[90px]" [(ngModel)]="costAnalysisMonth" view="month"
                                    [minDate]="datePickerMinYear" [maxDate]="gasForecastMaxDate" readonlyInput="true"
                                    dateFormat="MM" inputStyleClass="text-center w-full pt-1"
                                    (onClose)="changeMonth()" />
                                <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                }
                            </div>
                            <div
                                class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                <p-calendar class="w-[50px]" [(ngModel)]="costAnalysisYear" view="year"
                                    [minDate]="datePickerMinYear" [maxDate]="gasForecastMaxDate" readonlyInput="true"
                                    dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                    (onClose)="loadCostAnalysisData()" />
                                <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                            </div>
                        </div>
                        <div class="h-[2px] w-full bg-border mobile:mt-2"></div>
                    </div>
                </div>

                <div
                    class="flex flex-row gap-5 flex-wrap desktop:items-stretch justify-evenly mobile:flex-col min-h-[400px] mobile:gap-2 p-5 mobile:p-2">
                    <div
                        class="flex-[1] min-w-[300px] mobile:min-w-[300px] border-2 rounded-lg border-border p-6 mobile:w-full ">
                        <p class="text-primary text-center font-semibold ml-4 mt-4 pb-2 mobile:text-sm">
                            {{ 'dashboard.comparison_of_consumption_and_taxable_expenditure_gas' | transloco }}
                        </p>
                        <div class="h-[400px] largeScreen:h-[600px] w-[90%] mobile:w-full mobile:h-[300px]">
                            <app-gas-cost-analysis-chart [showDummyData]="showDummyData"
                                [lineCostTrendData]="capd_lineCostTrendData" [barSmcData]="capd_barSmcData"
                                [inputedPeriods]="capd_inputedPeriods" [SmcDifference]="capd_SmcDifference"
                                [costDifference]="capd_costDifference"></app-gas-cost-analysis-chart>
                        </div>
                    </div>

                    <div
                        class="flex-[1] min-w-[300px] mobile:min-w-[300px] border-2 rounded-lg border-border p-6 mobile:w-full">
                        <p class="text-primary text-center font-semibold ml-4 mt-4 pb-2 mobile:text-sm">{{
                            'dashboard.cost_per_smc' | transloco }}
                        </p>
                        <div class="relative h-[400px] largeScreen:h-[600px] w-[90%] mobile:w-full mobile:h-[300px]">
                            <app-gas-cost-per-smc-chart [showDummyData]="showDummyData"
                                [materialCostsDifferenceSign]="materialCostsDifferenceSign"
                                [materialCostsDifference]="materialCostsDifference"
                                [fixedCostsDifferenceSign]="fixedCostsDifferenceSign"
                                [fixedCostsDifference]="fixedCostsDifference" [tmsDifferenceSign]="tmsDifferenceSign"
                                [tmsDifference]="tmsDifference"
                                [additionalChargesDifferenceSign]="additionalChargesDifferenceSign"
                                [additionalChargesDifference]="additionalChargesDifference"
                                [taxesDifferenceSign]="taxesDifferenceSign" [taxesDifference]="taxesDifference"
                                [previousPeriodCostPerSmc]="previousPeriodCostPerSmc"
                                [currentPeriodCostPerSmc]="currentPeriodCostPerSmc" [inputedPeriods]="inputedPeriods">
                            </app-gas-cost-per-smc-chart>

                            <app-no-data-message [(visible)]="noDataPopUp"></app-no-data-message>

                        </div>
                    </div>

                    <div
                        class="flex-[1] min-w-[500px] mobile:min-w-[300px] flex flex-col gap-2 shadow-sm mobile:w-full">
                        <div
                            class="w-full flex flex-col justify-between items-center rounded-[16px] border-[1px] border-border bg-[#FBFCFB] h-full">
                            <div class="flex flex-col gap-4 min-h-[70px] justify-between w-full">
                                <p class="text-primary font-semibold ml-4 mt-4 mobile:text-sm">{{
                                    'dashboard.cost_break_down' | transloco }}</p>
                                <div class="flex">
                                    <div class="h-[2px] w-1/2 bg-primary"></div>
                                    <div class="h-[2px] w-1/2 bg-border"></div>
                                </div>

                            </div>


                            <div class="flex flex-col items-center justify-center h-full w-full">
                                <div class="h-[400px] largeScreen:h-[600px] w-[90%] mobile:w-full p-4 mobile:p-2">
                                    <app-gas-cost-breakdown-chart [showDummyData]="showDummyData"
                                        [showData]="costBreakdownData"
                                        [totalPricePerUnit]="totalPricePerUnit"></app-gas-cost-breakdown-chart>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>